export const letalkLinks = {
	notionTermsOfService: "https://tan-salt-995.notion.site/Links-P-blicos-2921e13628b845239d80bd2c91ae7fa7?pvs=4"
}

export const bumeLinks = {
	signIn: "https://bume.com/public/signin"
}
